import React, {ReactNode} from 'react'

import {Button} from '@daedalus/atlas/Button'
import {Divider} from '@daedalus/atlas/Divider'
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper'
import {Flex} from '@daedalus/atlas/helpers/Flex'
import {Grid} from '@daedalus/atlas/helpers/Grid'
import {Text} from '@daedalus/atlas/Text'
import {genericMessages} from '@daedalus/core/src/booking/messages'
import {
  BookingError,
  Psd2AuthStatusErrorType
} from '@daedalus/core/src/booking/types/ErrorResponse'
import {getRecoverableErrorMessages} from '@daedalus/core/src/booking/utils/bookingErrorHelpers'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

import {DateAndRoomsText} from '../../search/DateAndRoomsText'
import {ErrorMessagesLayout} from './ErrorMessagesLayout'

interface PropsType {
  checkIn: string
  checkOut: string
  rooms: string
  onClick: () => void
  bookingError: BookingError | Psd2AuthStatusErrorType
  redirectOffersSlot: ReactNode
  hotelCardSlot: ReactNode
  isPayAtProperty?: boolean
}

export const RecoverableErrorContentLayout = ({
  checkIn,
  checkOut,
  rooms,
  onClick = () => {},
  bookingError,
  redirectOffersSlot,
  hotelCardSlot,
  isPayAtProperty = false
}: PropsType) => {
  const errorMessage = getRecoverableErrorMessages(
    bookingError,
    isPayAtProperty
  )
  if (!errorMessage) return null

  return (
    <ContentWrapper padding="s500">
      <Grid gap="s500">
        <ErrorMessagesLayout
          titleSlot={<FormattedMessageWrapper {...errorMessage.title} />}
          descriptionSlot={
            <FormattedMessageWrapper {...errorMessage.description} />
          }
        />

        <Flex.Column gap="s600">
          <Button size="xl" variant="secondary" fullWidth onClick={onClick}>
            <FormattedMessageWrapper {...genericMessages.backToForm} />
          </Button>

          <Divider />
          <Flex.Column gap="s400">
            <Text
              variant="bodyM"
              colorPath="content.neutral.c600"
              align="center"
              dataId="errors.alternativeDealsText"
            >
              <FormattedMessageWrapper
                id="errors.alternativeDealsText"
                defaultMessage="Check out these similar deals from our trusted partners:"
              />
            </Text>
            <Flex.Row justifyContent="center">
              <DateAndRoomsText
                checkIn={checkIn}
                checkOut={checkOut}
                rooms={rooms}
                hasCustomStyle
              />
            </Flex.Row>
          </Flex.Column>
        </Flex.Column>
        <ContentWrapper paddingTop="s400">
          {hotelCardSlot}
          {redirectOffersSlot}
        </ContentWrapper>
      </Grid>
    </ContentWrapper>
  )
}
